module.exports = "img/pauseLittle2.1fd777.png";